export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8676.bfc328e8.jpg";